<template>
    <div class="-mt-2">
        <div class="splide" :id="id">
            <div class="splide__track">
                <ul class="splide__list">
                    <li
                        class="splide__slide"
                        v-for="(dashboard, k) in arrDashboard"
                        :key="`${id}-slide-item-${k}`"
                        @click="clickDashboard(dashboard)"
                    >
                        <div class="inner py-2 mx-auto text-center">
                            <img class="w-full rounded-2xl mx-auto" :src="dashboard.imageUrl" />
                        </div>

                        <!-- <img class="w-full" :src="dashboard.imageUrl"> -->
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <SplideCustomPagination :value="current" :total="arrDashboard.length" :disabled="true"></SplideCustomPagination>
    <!-- <div class="nothing-zone">
        <div class="hidden md:block" ref="md-screen"></div>
    </div>-->
</template>
<script>
//library
import Splide from '@splidejs/splide'; //https://splidejs.com/
//helper
import Locale from "@/helper/locale/Locale.js";
//service
import { SubDashboardConfigBuilder } from "@/core/Campaign/config/DashboardConfigModel.js";
import BzbsDashboard from "@/core/Campaign/service/BzbsDashboard.js";

import SplideCustomPagination from "@/components/Slider/SplideCustomPagination.vue"

/**
 * @event onLoaded
 */
export default {
    name: "DashboardSlider",
    props: {
        id: { type: String, default: "dashboard-slide" },
        apiConfig: { type: String, required: true },
    },
    emits: ["onMounted", "onLoaded"],
    components: {
        SplideCustomPagination
    },
    data: function () {
        return {
            show: false,
            arrDashboard: [],
            current: 0,
            splide: null,
            mdScreen: false
        };
    },
    mounted: function () {
        // let el = this.$refs['md-screen']
        // let computedStyle = getComputedStyle(el)
        // if (computedStyle.display == "block") {
        //     this.mdScreen = true
        // } else {
        //     this.mdScreen = false
        // }
        this.current = 0

        this.getDashboard();
    },
    beforeUnmount: function () {
        if(this.splide != null){
            this.splide.destroy()
        }
    },
    methods: {
        getDashboard: function () {
            var configBuilder = new SubDashboardConfigBuilder();
            configBuilder.setLocale(Locale.getLocaleCode());

            var params = configBuilder.create().getParams();
            BzbsDashboard.apiGetSubDashboard(params, this.apiConfig).subscribe((data) => {
                // console.log(data)
                this.arrDashboard = data;
                this.setSlider();

                this.$emit('onLoaded');
            }, (err) => {
                this.$emit('onLoaded');
                console.log(err);
            });
        },
        clickDashboard: function (dashboard) {
            if (dashboard.type == 'link') {
                window.open(dashboard.url, '_blank');
            } else if (dashboard.type == 'campaign') {
                this.$router.push('/promotion/detail/' + dashboard.id);
            }
            var tracking_label = dashboard.strGA ? dashboard.strGA : ''
            this.tracking.event('top_banner', 'click_top_banner', tracking_label, null);
        },
        setSlider: function () {
            // this.$nextTick(() => {

            // });

            this.splide = new Splide('#' + this.id, {
                type: 'loop',
                arrows: false,
                pagination: false,
                focus: 'center',
                autoWidth: true,
                perPage: 1,
                padding: 36,
                perMove: 1,
                start: 0,
            })

            this.splide.on("moved", (newIndex) => {
                this.current = newIndex
                // console.log(newIndex)
            })

            this.splide.on("mounted", () => {
                this.reFocus()

                this.$emit("onMounted")
            })
            // re-focus to solve problem that occur when using type: loop not generate last slide on left side when changing page
            this.$nextTick(() => {
                setTimeout(() => {
                    this.splide.mount();
                }, 100)
            })
        },
        reFocus: function () {
            this.$nextTick(() => {
                setTimeout(() => {
                    let opts = {
                        type: 'loop',
                        focus: 'center',
                    }

                    this.splide.options = opts
                }, 250);
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.splide__slide {
    .inner {
        transform: scale(0.9);
        transition: all;
        transition-duration: 200ms;
        // padding-left: 4px;
        // padding-right: 4px;
    }

    display: inline-flex;
    vertical-align: middle;

    img {
        // box-shadow: 0 0 10px 0 rgba(23, 55, 127, 0.31);
        // height: 183px;
        max-height: 200px;
        max-width: 300px;
    }

    &.is-active {
        .inner {
            transform: scale(1);
        }
    }
}
</style>
